module.exports = __webpack_public_path__ + "img/builder4bots.6ca4ef02.svg";